import { render, staticRenderFns } from "./Children.vue?vue&type=template&id=143117c9"
import script from "./Children.vue?vue&type=script&lang=js"
export * from "./Children.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports